exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.flex-between[data-v-511ea20c] { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; -webkit-box-pack: justify; -ms-flex-pack: justify; justify-content: space-between;\n}\n.title[data-v-511ea20c] { font-size: 16px; font-weight: 600;\n}\n.mb14[data-v-511ea20c] { margin-bottom: 14px;\n}\n.json-pre[data-v-511ea20c] { padding: 16px; white-space: pre-wrap; word-break: break-all; font-size: 12px;\n}\n.page-fixed[data-v-511ea20c] { margin-top: 12px; text-align: right;\n}\n", ""]);

// exports
